import React from "react";
import { GET } from '../../../utils/AxiosRequest'

import { Button, Dialog, DialogActions, DialogContent, DialogTitle, MenuItem, Stack, TextField, useTheme } from "@mui/material";
import { BonLivraisonViewer } from "../BonLivraisonViewer";

export const CreateBonLivraison = (props) => {
    const theme = useTheme();
    const [open, setOpen] = React.useState(false);
    const [devisList, setDevisList] = React.useState([]);
    const [selectedDevis, setSelectedDevis] = React.useState(0);
    const [numeroCommande, setNumeroCommande] = React.useState("");
    const pdfRef = React.useRef(null);

    function ChangeSelectedDevis(event) {
        setSelectedDevis(event.target.value);
        var devis = devisList.find(element => element.id === event.target.value);
        setNumeroCommande((devis.numeroCommande) ? devis.numeroCommande : "");
    }

    function HandleOpen(){
        return GetAllDevisFromDb()
        .then(data => {
            setDevisList(data)
            setSelectedDevis(data[0].id);
            setNumeroCommande(data[0].numeroCommande)
            setOpen(true);
        })
    }

    function HandleClose(save){
        setOpen(false);
        if(save){
            var id = 0;
            var devis = [];
            return Promise.all([
                GET("bonLivraison/getNewBLId"),
                GET("factures/getDevisById", {id: selectedDevis}),
            ]).then(data => {
                id = data[0][0].id + 1;
                devis = data[1][0];
                return GET("factures/getClientById", {id: devis.idClient})
            }).then(data => {
                pdfRef.current.handleOpen(id, devis, data, true);
            })

        }
        setNumeroCommande("");
    }

    //#region AXIOS REQUEST
    function GetAllDevisFromDb() { return GET("factures/getAllDevis") }
    //#endregion
    
    return (
        <div>
            <Button fullWidth variant="contained" onClick={() => HandleOpen()} >Créer un bon de livraison</Button>
            <Dialog fullWidth maxWidth="md" open={open} onClose={() => HandleClose(false)}>
				<DialogTitle color={theme.palette.text.primary}>Créer un bon de livraison</DialogTitle>
				<DialogContent>
					<Stack spacing={2} direction="column">
                        <TextField select variant="standard" label="Devis pour le bon de livraison" value={selectedDevis} onChange={ChangeSelectedDevis}>
                            {devisList && devisList.map(devis => (
                                <MenuItem key={devis.id} value={devis.id}>{devis.nom + " - " + devis.nomEntite}</MenuItem>
                            ))}
                        </TextField>
                        <TextField variant="standard" label="Numéro de commande" disabled value={numeroCommande} onChange={(event) => setNumeroCommande(event.target.value)} />
					</Stack>
				</DialogContent>
				<DialogActions>
					<Button onClick={() => HandleClose(true)} color="success">Créer un bon</Button>
					<Button onClick={() => HandleClose(false)}>Retour</Button>
				</DialogActions>
			</Dialog>
            <BonLivraisonViewer ref={pdfRef}/>
        </div>
    )
}